import React, { Component } from "react";
import PropTypes from "prop-types";
import reduxForm, { Form, InputField } from "components/form";
import { validateEmail as vEmail } from "common/validators";
import { Button } from "components/ui";
import { Link } from "react-router-dom";

const validateRequired = valueString => (valueString ? undefined : "Укажите электронную почту");
const validateEmail = value => (vEmail(value) ? undefined : "Электронная почта не верна");

@reduxForm({ form: "forgotForm" })
export default class ForgotForm extends Component {
	static propTypes = {
		handleSubmit: PropTypes.func,
		isLoading: PropTypes.bool,
		onSubmit: PropTypes.func
	};

	render() {
		const { handleSubmit, isLoading, onSubmit } = this.props;

		return (
			<Form onSubmit={handleSubmit(onSubmit)}>
				<div className="mb-4">
					<i className="feather icon-unlock auth-icon" />
				</div>

				<h4 className="mb-4">Восстановление пароля</h4>

				<div className="input-group m-b-5">
					<InputField
						name="email"
						label="Электронная почта"
						validate={[validateRequired, validateEmail]}
						prefix={<i className="feather icon-mail" />}
						autoFocus
					/>
				</div>

				<Button htmlType="submit" type="primary" loading={isLoading}>
					Запросить пароль
				</Button>

				<p className="p-t-15 mb-2 text-muted">
					<Link to="/sign-in">Авторизация</Link>
				</p>
			</Form>
		);
	}
}
